export default __webpack_public_path__ + "static/media/ticket-icon.fd0570b0.svg";